module.exports = __webpack_public_path__ + "static/media/thumbnail.dea668d3.jpg";